module.exports = __webpack_public_path__ + "static/img/次元兽决战1.5a648001.png";